// extracted by mini-css-extract-plugin
export default {"cls1":"GroupCsvUpload-FooterLinks_cls1__pn-Q9","cls2":"GroupCsvUpload-FooterLinks_cls2__ezRXn GroupCsvUpload-FooterLinks_cls1__pn-Q9"};